import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const TourPlanList = Loadable(lazy(() => import("./TourPlanList")));
const TourPlanForm = Loadable(lazy(() => import("./TourPlanForm")));

const tourPlanRoutes = [
    {
        path: "/TourPlan/TourPlanList",
        element: <TourPlanList />,
        permission: PERMISSIONS.TourPlans.Menu,
    },
    {
        path: "/TourPlan/TourPlanForm",
        element: <TourPlanForm />,
    },
    {
        path: "/TourPlan/TourPlanForm/:tourPlanId",
        element: <TourPlanForm />,
    },
];

export default tourPlanRoutes;
